import store from '../store';
import StudentProfile from '@/classes/StudentProfile';

interface ICertificate {
    id?: number;
    studentId?: number;
    dolId?: string;
    jobCorpCenterId?: number;
    certificationId?: number;
    certificationDate?: string;
    certificationPrintStatus?: boolean;
    instructorId?: number;
    certificateFormId?: number;
    updated?: string;
    certificateStatus?: string;
    printingComplete?: Date;
    printedById?: number;
    canPrint?: boolean;
    isCompletionCertificate?: boolean;
}

class Certificate implements ICertificate {

    public id?: number;
    public studentId?: number;
    public dolId?: string;
    public jobCorpCenterId?: number;
    public certificationId?: number;
    public certificationDate?: string;
    public certificationPrintStatus?: boolean;
    public instructorId?: number;
    public updated?: string;
    public certificateStatus?: string;
    public printingComplete?: Date;
    public printedById?: number;
    public canPrint?: boolean;
    public jobCorpCenterNameIndex: number;
    public studentNameIndex: number;
    public instructorNameIndex: number;
    public certificationNameIndex: number;
    public certificateFormId?: number;
    public certificationDateAsNumber: number;
    public printingCompleteAsNumber: number;
    public studentStatusIndex: number;

    public editCertificationDate?: string;

    constructor(c: ICertificate = {}) {
        this.id = c.id;
        this.studentId = c.studentId;
        this.dolId = c.dolId;
        this.jobCorpCenterId = c.jobCorpCenterId;
        this.certificationId = c.certificationId;
        this.certificationDate = c.certificationDate;
        this.certificationPrintStatus = c.certificationPrintStatus;
        this.instructorId = c.instructorId;
        this.updated = c.updated;
        this.certificateStatus = c.certificateStatus;
        this.printingComplete = c.printingComplete ? new Date(c.printingComplete) : undefined;
        this.printedById = c.printedById;
        this.canPrint = c.canPrint;
        this.certificateFormId = c.certificateFormId;
        this.certificationDateAsNumber = this.setCertificationDateAsNumber();
        this.printingCompleteAsNumber = this.setPrintingCompleteAsNumber();
        this.jobCorpCenterNameIndex = this.setCenterNameIndex();
        this.studentNameIndex = this.setStudentNameIndex();
        this.instructorNameIndex = this.setInstructorNameIndex();
        this.certificationNameIndex = this.setCertificationNameIndex();
        this.studentStatusIndex = this.setStudentStatusIndex();
    }

    public getPrintedDate(): Date | null {
        return this.certificationPrintStatus && this.updated ? new Date(this.updated) : null;
    }

    public setCertificationDateAsNumber(): number {
        if (this.certificationDate !== undefined) {
            return new Date(this.certificationDate).getTime();
        } else {
            return -1;
        }
    }

    public setPrintingCompleteAsNumber(): number {
        if (this.printingComplete !== undefined) {
            return new Date(this.printingComplete).getTime();
        } else {
            return -1;
        }
    }

    public setCenterNameIndex(): number {
        return store.getters.getJobCorpsCenterNameIndex(this.jobCorpCenterId);
    }

    public setStudentNameIndex(): number {
        return store.getters['students/getStudentNameIndexById'](this.studentId);
    }

    public setStudentStatusIndex(): number {
        const student: StudentProfile | undefined = store.getters['students/getStudentById'](this.studentId);
        if (student !== undefined) {
            return student.active ? 1 : 0;
        } else {
            return 0;
        }

    }

    public setInstructorNameIndex(): number {
        return store.getters.getUserNameIndexById(this.instructorId);
    }

    public setCertificationNameIndex(): number {
        return store.getters.getCertificationNameIndexById(this.certificationId);
    }
}

export default Certificate;
export { Certificate, ICertificate };
